export default __webpack_public_path__ + "static/media/arrow-right-small.35bec810.svg";